import { StoreState } from '@/redux/types';
import { getContext } from './getContext';

export const getSpecialFontCommission = (state: StoreState) => {
  const context = getContext(state);
  if (
    context.priceStrategy.type === 'CyoPriceStrategy' &&
    context.priceStrategy.cyoSpecialFontCommission
  ) {
    return context.priceStrategy.cyoSpecialFontCommission.amount;
  }
  return null;
};
